import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ngo',
  templateUrl: './ngo.component.html',
  styleUrls: ['./ngo.component.scss']
})
export class NgoComponent implements OnInit {
  questionTitle = $localize`:@@ngoContactTitle:Do you participate in a NGO?`;

  ngoSupportImage = `https://cdn.sanity.io/images/jizm7zxy/production/8452f2db227e92527c8ea151d4b4e0db9251847b-800x600.png?fm=webp&q=75`;

  constructor() {}

  ngOnInit(): void {}
}
